import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BASE_URL from '../config/config';
// Importamos react-loading-skeleton
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CapacidadPorSemana = () => {
  // Estado para controlar la carga
  const [loading, setLoading] = useState(true);
  // Estado donde guardamos el JSON proveniente de /timetracking/summary
  const [summary, setSummary] = useState({});
  // Horas semanales configurables
  const [weeklyHours, setWeeklyHours] = useState(38.5);

  // Estados para la selección de semana, mes, año
  const [selectedWeek, setSelectedWeek] = useState('Semana1');
  const [selectedMonth, setSelectedMonth] = useState('01');
  const [selectedYear, setSelectedYear] = useState('2025');

  // 1. Obtener el JSON de /timetracking/summary
  const getTimeTrackingSummary = async () => {
    try {
      setLoading(true); // comenzamos la carga
      const response = await axios.get(`${BASE_URL}/api/timetracking/summary`);
      setSummary(response.data);
    } catch (error) {
      console.error('Error al obtener el summary de timetracking:', error);
    } finally {
      setLoading(false); // finalizamos la carga
    }
  };

  // Llamamos a la función cuando se monta el componente
  useEffect(() => {
    getTimeTrackingSummary();
  }, []);

  // 2. Función para calcular la capacidad (horas disponibles) de un empleado
  // para la semana/mes/año seleccionados
  const calcularCapacidadEmpleado = (nombreEmpleado) => {
    if (!summary[nombreEmpleado]) {
      // Si no hay datos para este empleado, 0
      return { horasTrabajadas: 0, capacidad: 0 };
    }

    // Construimos la clave que buscamos. Ej: "Semana1/03/2024"
    const clave = `${selectedWeek}/${selectedMonth}/${selectedYear}`;

    // Horas trabajadas (si no existe la clave, asumimos 0)
    const horasTrabajadasString = summary[nombreEmpleado][clave];
    const horasTrabajadas = horasTrabajadasString
      ? parseFloat(horasTrabajadasString)
      : 0;

    // Capacidad = horas semanales - horas trabajadas
    const capacidad = weeklyHours - horasTrabajadas;

    return {
      horasTrabajadas,
      capacidad: capacidad,
    };
  };

  // Empleados (las claves del objeto summary)
  const empleados = Object.keys(summary);

  // Listas de selección
  const listaSemanas = ['Semana1', 'Semana2', 'Semana3', 'Semana4'];
  const listaAnios = ['2020','2021','2022','2023','2024','2025'];
  const listaMeses = [
    { label: 'Enero', value: '01' },
    { label: 'Febrero', value: '02' },
    { label: 'Marzo', value: '03' },
    { label: 'Abril', value: '04' },
    { label: 'Mayo', value: '05' },
    { label: 'Junio', value: '06' },
    { label: 'Julio', value: '07' },
    { label: 'Agosto', value: '08' },
    { label: 'Septiembre', value: '09' },
    { label: 'Octubre', value: '10' },
    { label: 'Noviembre', value: '11' },
    { label: 'Diciembre', value: '12' },
  ];

  return (
    <main className="bg-gris">
      <div className="site-width dashboard-grid">
        <div className="dashboard-content">
          <h2>Empleados</h2>
          <p>Consulta el rendimiento de los empleados. Este método no incluye días de vacaciones ni festivos, holded no proporciona esa información.<br/>NOTA: Esta información es una aproximación. Puede afectar al cálculo diversos factores (Ej: personales, horas extra, formación...)</p>
          <p className='formula'>FÓRMULA: Horas semanales de trabajo indicadas en contrato - Total de horas imputadas (No modificables)</p>
          <div className="selector-ocioso">

            {/* Selector de horas semanales */}
            <input
              type="number"
              id="weeklyHours"
              placeholder='Horas del contrato'
              value={weeklyHours}
              onChange={(e) => setWeeklyHours(parseFloat(e.target.value))}
            />
            <select
              id="selectWeek"
              value={selectedWeek}
              onChange={(e) => setSelectedWeek(e.target.value)}
            >
              {listaSemanas.map((sem) => (
                <option key={sem} value={sem}>{sem}</option>
              ))}
            </select>
            <select
              id="selectMes"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {listaMeses.map((mes) => (
                <option key={mes.value} value={mes.value}>
                  {mes.label}
                </option>
              ))}
            </select>
            <select
              id="selectYear"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {listaAnios.map((anio) => (
                <option key={anio} value={anio}>
                  {anio}
                </option>
              ))}
            </select>
          </div>

          {/* Mostramos Skeleton mientras loading === true */}
          {loading ? (
            <div className='grid-empleados'>
              {/* Por ejemplo, 5 skeletons de ejemplo */}
              {Array.from({ length: 10 }).map((_, i) => (
                <Skeleton key={i} width={250} height={180} />
              ))}
            </div>
          ) : (
            <div className='grid-empleados'>
              {/* Cuando ya cargó, mostramos la capacidad de cada empleado */}
              {empleados.length > 0 ? (
                empleados.map((nombreEmpleado) => {
                  const { horasTrabajadas, capacidad } = calcularCapacidadEmpleado(nombreEmpleado);
                  const horasOciosas = capacidad.toFixed(2);
                  // Calculamos el porcentaje de imputación = (horasTrabajadas / weeklyHours) * 100
                  const porcentajeImputacion = (horasTrabajadas / weeklyHours) * 100 || 0;

                  return (
                    <div key={nombreEmpleado} className='item-empleado'>
                      <h3>{nombreEmpleado}</h3>
                      <p><b>{horasOciosas}</b> horas ociosas</p>
                      <p>% de Imputación: <b>{porcentajeImputacion.toFixed(2)}%</b></p>
                    </div>
                  );
                })
              ) : (
                <p className='no-proyectos-disp'>Error al acceder a la API de holded.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default CapacidadPorSemana;
